module.exports = __webpack_public_path__ + "media/Video 147.c50a272d.mp4";